<template>
  <div class="app-optimization-container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "AppOptimization"
};
</script>

<style lang="scss" scoped>
.app-optimization-container {
  width: 100%;
  height: 100%;
}
</style>
